import type { Transaction } from '@asia/shared';
import { rpc } from './ws';

export interface Balances {
  trx: number;
  usdt: number;
}

/** On-chain USDT + TRX balances for an address (whole units). */
export const fetchBalances = (_token: string, address: string) =>
  rpc<Balances>('tron.balances', { address });

export interface TxPage {
  txs: Transaction[];
  /** Timestamp cursor for the next (older) page, or null at the end. */
  nextBefore: number | null;
}

/** One page of USDT + TRX transfers, newest first. `before` is a timestamp cursor
 *  (from a previous page's nextBefore) for infinite scroll. */
export const fetchTxs = (_token: string, address: string, before?: number) =>
  rpc<TxPage>('tron.txs', before ? { address, before } : { address });

/** Subscribe/unsubscribe to server-pushed balance + tx updates for addresses. */
export const watchAddresses = (addresses: string[]) =>
  rpc<{ ok: boolean }>('tron.watch', { addresses });

export const unwatchAddresses = (addresses: string[]) =>
  rpc<{ ok: boolean }>('tron.unwatch', { addresses });
